import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Loader2, Rocket } from 'lucide-react';

interface PegarPedidoDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  numeroPedido: string;
  razaoSocial: string;
  /** Quantos pedidos JÁ pegos por esta pessoa ainda esperando criação. */
  meusEsperando: number;
  isLoading: boolean;
  onConfirm: () => void;
}

/**
 * "Pegou = é seu" (Douglas, 18/08/2026): o pedido sai da conferência com dono,
 * data e hora, e vai para a fila de criação DESTA pessoa. O aviso existe para
 * acabar com o hábito de empurrar a fila inteira para a Criação e não fazer.
 */
export function PegarPedidoDialog({
  open,
  onOpenChange,
  numeroPedido,
  razaoSocial,
  meusEsperando,
  isLoading,
  onConfirm,
}: PegarPedidoDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(o) => !isLoading && onOpenChange(o)}>
      <DialogContent className="sm:max-w-[520px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Rocket className="h-5 w-5 text-primary" />
            Pegar e criar — Pedido {numeroPedido}
          </DialogTitle>
          <DialogDescription>{razaoSocial}</DialogDescription>
        </DialogHeader>

        <div className="space-y-3 py-1">
          <div className="rounded-md border border-border border-l-[3px] border-l-primary bg-card p-3">
            <p className="text-xs font-bold uppercase tracking-wider text-muted-foreground">
              Pegou = é seu
            </p>
            <p className="mt-1 text-sm text-foreground">
              O pedido entra na <strong>sua</strong> fila de criação com o seu nome, e a
              contagem de tempo começa agora. Ninguém mais vai criar este contrato por você.
            </p>
          </div>

          {meusEsperando > 0 && (
            <p className="text-sm text-muted-foreground">
              Você já tem{' '}
              <span className="font-bold tabular-nums text-primary">{meusEsperando}</span>{' '}
              {meusEsperando === 1 ? 'pedido seu esperando' : 'pedidos seus esperando'} criação.
            </p>
          )}
        </div>

        <div className="flex items-center justify-end gap-2">
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
          >
            Cancelar
          </Button>
          <Button type="button" size="sm" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? (
              <>
                <Loader2 className="mr-1 h-3.5 w-3.5 animate-spin" /> Pegando…
              </>
            ) : (
              <>
                <Rocket className="mr-1 h-3.5 w-3.5" /> Pegar e criar
              </>
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
